import { jsx as _jsx } from "react/jsx-runtime";
import cx from "classnames";
import styles from "./wrapper.module.css";
const Wrapper = ({ children , isFullHeight , isFluid , isSlim , hasOverflow , className , backgroundColor ="transparent" , ...rest })=>{
    const classNames = cx(styles.wrapper, {
        [styles.container]: !isFluid,
        [styles.wrapperFullHeight]: isFullHeight,
        [styles.slimContainer]: !isFluid && isSlim,
        [styles.wrapperOverflow]: !hasOverflow
    }, className === null || className === void 0 ? void 0 : className.inner);
    return /*#__PURE__*/ _jsx("section", {
        className: className === null || className === void 0 ? void 0 : className.container,
        style: {
            backgroundColor
        },
        children: /*#__PURE__*/ _jsx("div", {
            className: classNames,
            ...rest,
            children: children
        })
    });
};
export default Wrapper;
